import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './polyfills/polyfills.js';
import './gtm';

Vue.config.productionTip = false;

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
